import { Spinner } from "@/ds/shadcn/components/ui/spinner";
import { cn } from "@/ds/utils";
import type { PaginatedInfiniteQueryResult } from "@/lib/common/PaginatedInfiniteQueryResult";
import { useInfiniteScroll } from "@/lib/common/useInfiniteScroll";
import { useRef, type RefObject } from "react";

export interface GalleryInfiniteScrollerProps<T> {
	forQuery: PaginatedInfiniteQueryResult<T>;
	scrollRef?: RefObject<HTMLElement | null>;
}

export const GalleryInfiniteScroller = <T,>(props: GalleryInfiniteScrollerProps<T>): React.JSX.Element => {
	const {
		forQuery,
		scrollRef
	} = props;

	const ref = useRef<HTMLDivElement | null>(null);
	const showLoader = useInfiniteScroll(ref, forQuery, scrollRef);

	return (
		<div ref={ref} className={cn("rounded-md border p-6 flex justify-center items-center", !showLoader && "hidden")}>
			<Spinner />
		</div>
	);
};
